<template>
    <v-autocomplete
            label="Provincia"
            :items="provincias"
            :value="value"
            :multiple="multiple"
            hide-details
            :chips="chips"
            item-value="id"
            item-text="desig"
            @input="actualizaValor($event)"
    >
    </v-autocomplete>
</template>
<script>
    export default {
        name: 'provincia-select',
        props: ['multiple', 'value','chips'],
        data() {
            return {
                provincias: []
            }
        },
        mounted(){
            this.$http.post('provincia/select')
                .then(r => {
                    this.provincias = r.data;
                })
        },
        methods: {
            actualizaValor(valor) {
                this.$emit('input', valor)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ProvinciaSelect.vue